<template>
  <div id="nlp">
    <div class="npl__overflow">
      <div
        class="nlp__header"
        :class="{ 'nlp__header--scrolled': isScrolled }"
      >
        <div class="nlp__wrapper">
          <NlpHeader :is-scrolled="isScrolled" />
        </div>
      </div>
      <div
        class="nlp__main"
        :class="{ 'nlp__z-index-block': getZIndexBlock == 'main' }"
      >
        <div class="nlp__main-background-left">
          <img
            alt="background-left"
            :src="require('@/assets/images/nlp/main-background-left.png')"
          >
        </div>
        <div class="nlp__main-background-right">
          <img
            alt="background-right"
            :src="require('@/assets/images/nlp/main-background-right.png')"
          >
        </div>
        <div class="nlp__wrapper">
          <NlpMain />
        </div>
      </div>
      <div
        id="risks"
        class="nlp__why-check nlp__vertical-rythm"
      >
        <div class="nlp__background-left">
          <NlpLeftBackground />
        </div>
        <div class="nlp__background-right">
          <NlpRightBackground />
        </div>
        <div class="nlp__wrapper">
          <NlpWhyCheck />
        </div>
      </div>
      <div class="nlp__block-coins nlp__vertical-rythm">
        <div class="nlp__wrapper">
          <NlpBlockCoins />
        </div>
      </div>
      <div class="nlp__who-is-for nlp__vertical-rythm">
        <div class="nlp__background-left">
          <NlpLeftBackground />
        </div>
        <div class="nlp__background-right">
          <NlpRightBackground />
        </div>
        <div class="nlp__wrapper">
          <NlpWhoIsFor />
        </div>
      </div>
      <div
        id="solutions"
        class="nlp__why-satoshi nlp__vertical-rythm"
      >
        <div class="nlp__wrapper">
          <NlpWhySatoshi />
        </div>
      </div>
      <div class="nlp__how-it-works nlp__vertical-rythm">
        <div class="nlp__wrapper">
          <NlpHowItWorks />
        </div>
      </div>
      <div class="nlp__what-in-report nlp__vertical-rythm">
        <div class="nlp__background-left">
          <NlpLeftBackground />
        </div>
        <div class="nlp__background-right">
          <NlpRightBackground />
        </div>
        <div class="nlp__wrapper">
          <NlpWhatInReport />
        </div>
      </div>
      <div
        class="nlp__check-address nlp__vertical-rythm"
        :class="{ 'nlp__z-index-block': getZIndexBlock == 'check-address' }"
      >
        <div class="nlp__wrapper">
          <NlpCheckAddress />
        </div>
      </div>
      <div
        v-if="showPricingBlock"
        id="pricing"
        class="nlp__pricing nlp__vertical-rythm"
      >
        <div class="nlp__background-left">
          <NlpLeftBackground />
        </div>
        <div class="nlp__background-right">
          <NlpRightBackground />
        </div>
        <div class="nlp__wrapper">
          <NlpPricing />
        </div>
      </div>
      <div
        id="faq"
        class="nlp__faq nlp__vertical-rythm"
      >
        <div class="nlp__background-left">
          <NlpLeftBackground />
        </div>
        <div class="nlp__background-right">
          <NlpRightBackground />
        </div>
        <div class="nlp__wrapper">
          <NlpFaq />
        </div>
      </div>
      <div class="nlp__subscribe nlp__vertical-rythm">
        <div class="nlp__background-left">
          <NlpLeftBackground />
        </div>
        <div class="nlp__background-right">
          <NlpRightBackground />
        </div>
        <div class="nlp__wrapper">
          <NlpSubscribe />
        </div>
      </div>
      <div class="nlp__footer">
        <div class="nlp__wrapper">
          <NlpFooter />
        </div>
      </div>
      <NlpBurgerMenu />
    </div>
  </div>
</template>

<script>
// Components
import NlpBurgerMenu from '@/pages/landing-page/components/NlpBurgerMenu.vue'
import NlpHeader from '@/pages/landing-page/blocks/NlpHeader.vue'
import NlpFooter from '@/pages/landing-page/blocks/NlpFooter.vue'
import NlpMain from '@/pages/landing-page/blocks/NlpMain.vue'
import NlpWhyCheck from '@/pages/landing-page/blocks/NlpWhyCheck.vue'
import NlpBlockCoins from '@/pages/landing-page/blocks/NlpBlockCoins.vue'
import NlpWhoIsFor from '@/pages/landing-page/blocks/NlpWhoIsFor.vue'
import NlpWhySatoshi from '@/pages/landing-page/blocks/NlpWhySatoshi.vue'
import NlpHowItWorks from '@/pages/landing-page/blocks/NlpHowItWorks.vue'
import NlpWhatInReport from '@/pages/landing-page/blocks/NlpWhatInReport.vue'
import NlpCheckAddress from '@/pages/landing-page/blocks/NlpCheckAddress.vue'
import NlpPricing from '@/pages/landing-page/blocks/NlpPricingV2.vue'
import NlpFaq from '@/pages/landing-page/blocks/NlpFaq.vue'
import NlpSubscribe from '@/pages/landing-page/blocks/NlpSubscribe.vue'
import NlpLeftBackground from '@/pages/landing-page/svg/NlpLeftBackground.vue'
import NlpRightBackground from '@/pages/landing-page/svg/NlpRightBackground.vue'

// Vuex
import { mapGetters, mapMutations } from 'vuex'

// Utils
import { nlpScrollToViewSelector } from '@/utils/scroll-to'

export default {
  name: 'NlpLandingPage',
  components: {
    NlpBurgerMenu,
    NlpHeader,
    NlpFooter,
    NlpMain,
    NlpWhyCheck,
    NlpBlockCoins,
    NlpWhoIsFor,
    NlpWhySatoshi,
    NlpHowItWorks,
    NlpWhatInReport,
    NlpCheckAddress,
    NlpPricing,
    NlpFaq,
    NlpSubscribe,
    NlpLeftBackground,
    NlpRightBackground,
  },
  data() {
    return {
      scrollY: 0,
      ticking: false,
      loadingPackages: false,
    }
  },
  computed: {
    ...mapGetters('nlp', ['getZIndexBlock']),
    ...mapGetters('user', ['isLogin']),
    ...mapGetters('payment', ['getCurrentPlan']),
    showPricingBlock() {
      if (!this.isLogin) return true
      const plan = this.getCurrentPlan
      if (!plan) return true
      return plan.planTier === 'free'
    },
    isScrolled() {
      return this.scrollY > 0
    }
  },
  mounted() {
    this.scrollY = window.scrollY
    window.addEventListener('scroll', this.onScroll, { passive: true })

    this.observeActiveSection()

    const section = this.$route.params.section
    if (section) {
      this.$nextTick(() => {
        this.scrollToSection(section, 1000, -128)
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('scroll', this._onSectionScroll)
  },
  methods: {
    ...mapMutations('nlp', ['SET_Z_INDEX_BLOCK', 'SET_ACTIVE_HEADER_SECTION']),
    nlpScrollToViewSelector,
    onScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.scrollY = window.scrollY
          this.ticking = false
        })
        this.ticking = true
      }
    },
    scrollToSection(anchor, timeout = 0, offset = 0) {
      if (anchor) {
        const el = document.querySelector(anchor)

        if (el) {
          setTimeout(() => {
            const elTop = el.getBoundingClientRect().top + window.scrollY + offset
            window.scrollTo({ top: elTop, behavior: 'smooth' })
          }, timeout)
        }
      }
    },
    observeActiveSection() {
      const sectionIds = ['risks', 'solutions', 'pricing', 'faq']
      let currentActive = null

      const checkActiveSection = () => {
        const scrollTop = window.scrollY
        let matched = null

        for (let i = sectionIds.length - 1; i >= 0; i--) {
          const id = sectionIds[i]
          const el = document.getElementById(id)
          if (el) {
            const offsetTop = el.offsetTop
            if (scrollTop >= offsetTop - 300) {
              matched = id
              break
            }
          }
        }

        if (matched !== currentActive) {
          currentActive = matched
          this.SET_ACTIVE_HEADER_SECTION(matched)
        }
      }

      this._onSectionScroll = () => {
        requestAnimationFrame(checkActiveSection)
      }

      window.addEventListener('scroll', this._onSectionScroll)
    },
  },
}
</script>

<style scoped>
#nlp {
  min-height: 100dvh;
  background-color: #F7FAFC;
  font-family: 'Satoshi', sans-serif;
  overflow: hidden;
}
#nlp::v-deep input, #nlp::v-deep button {
  font-family: 'Satoshi', sans-serif;
}

#nlp::v-deep input::placeholder {
  font-weight: 400;
}
::v-deep p {
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  color: #5A627D;
}
::v-deep h1, ::v-deep h2, ::v-deep h3 {
  font-weight: 900;
  color: #1C1C1C;
  text-align: center;
}
::v-deep h1 {
  font-size: 58px;
  line-height: 66px;
}
::v-deep h2 {
  font-size: 44px;
  line-height: 58px;
}
::v-deep h3 {
  font-size: 20px;
  line-height: 28px;
}
::v-deep h1 span,
::v-deep h2 span {
  background: linear-gradient(90deg, #194BFB 0%, #194BFB 25%, #CA0FA2 50%, #F1104E 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
::v-deep svg {
  display: block;
  backface-visibility: hidden;
}
.nlp__background-left {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.nlp__background-right {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}
.nlp__wrapper {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 24px;
  position: relative;
  z-index: 2;
}
::v-deep .nlp__button-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding-top: 48px;
}
.nlp__vertical-rythm {
  margin-bottom: 180px;
}
.nlp__z-index-block {
  z-index: 3 !important;
}

/* Header */
.nlp__header {
  padding-top: 24px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
}

.nlp__main,
.nlp__why-check,
.nlp__block-coins,
.nlp__who-is-for,
.nlp__why-satoshi,
.nlp__how-it-works,
.nlp__what-in-report,
.nlp__check-address,
.nlp__pricing,
.nlp__faq,
.nlp__subscribe {
  position: relative;
  z-index: 1;
}

/* Main */
.nlp__main {
  position: relative;
}
.nlp__main-background-left,
.nlp__main-background-right {
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
}
.nlp__main-background-left {
  left: 0;
}
.nlp__main-background-right {
  text-align: right;
  right: 0;
}
.nlp__main-background-left img,
.nlp__main-background-right img {
  max-height: 100%;
}

/* who it is for */
.nlp__who-is-for .nlp__wrapper {
  max-width: 1038px;
}

/* what in report */
.nlp__what-in-report .nlp__wrapper {
  max-width: 1038px;
}

.nlp__check-address.nlp__vertical-rythm {
  margin-bottom: 96px;
}

.nlp__pricing.nlp__vertical-rythm {
  margin-bottom: 159px;
}

.nlp__pricing .nlp__wrapper {
  padding: 0;
}

/* faq */
.nlp__faq .nlp__wrapper {
  max-width: 838px;
}


@media (max-width: 1279px) {
  /* who it is for */
  .nlp__who-is-for .nlp__wrapper {
    max-width: 680px;
  }

  /* why satoshi */
  .nlp__why-satoshi .nlp__wrapper {
    max-width: 680px;
  }

  /* how it works */
  .nlp__how-it-works .nlp__wrapper {
    max-width: 760px;
  }

  .nlp__pricing.nlp__vertical-rythm {
    margin-bottom: 73px;
  }
}
@media (max-width: 767px) {
  #nlp {
    padding-top: 0;
  }
  .nlp__background-left {
    transform: translate(-10%, 0);
  }
  .nlp__background-right {
    transform: translate(10%, 0);
  }
  .nlp__wrapper {
    padding: 0 16px;
  }
  ::v-deep h1 {
    font-size: 40px;
    line-height: 48px;
  }
  ::v-deep h2 {
    font-size: 32px;
    line-height: 46px;
  }
  ::v-deep .nlp__button-box {
    padding-top: 32px;
  }
  .nlp__vertical-rythm {
    margin-bottom: 120px;
  }

  /* Header */
  .nlp__header {
    padding-top: 0;
  }
  .nlp__header .nlp__wrapper {
    padding: 0;
  }

  /* Main */
  .nlp__main-background-right {
    display: none;
  }

  /* how it works */
  .nlp__how-it-works .nlp__wrapper {
    max-width: 480px;
    padding: 0;
  }

  /* what in report */
  .nlp__what-in-report .nlp__wrapper {
    max-width: 480px;
  }

  /* check address */
  .nlp__check-address .nlp__wrapper {
    padding: 0;
  }

  /* subscribe */
  .nlp__subscribe .nlp__wrapper {
    padding: 0;
  }
}
</style>
